<script>
  export default {
    name: 'NodeDecorator',
    functional: true,
    render: function (createElement, context) {
      const noNodes = !context.children

      if (noNodes) {
        return
      }

      const {
        children: nodes
      } = context

      const decoratedNodes = nodes.filter(function (node) {
        // exclude white space
        if (isWhiteSpace(node)) {
          return false
        }

        // exclude nodes that aren't components
        if (isNotAComponent(node)) {
          return false
        }

        // we need the props
        if (noProps(node)) {
          return false
        }

        // we need attributes
        if (noAttributes(context)) {
          return true
        }

        // add the props
        addPropsToNode(node, context)

        return true
      })

      return decoratedNodes
    }
  }

  const addPropsToNode = function (node, context) {
    const nodeProps = node.componentOptions.propsData
    const decoratorProps = context.data.attrs

    const decoratedNodeProps = Object.assign({}, nodeProps, decoratorProps)

    node.componentOptions.propsData = decoratedNodeProps
  }

  const noAttributes = function (context) {
    const noAttributes = typeof context.data.attrs === 'undefined'

    if (noAttributes) {
      return true
    }

    return false
  }

  const noProps = function (node) {
    const noProps = typeof node.componentOptions.propsData === 'undefined'

    if (noProps) {
      return true
    }

    return false
  }

  const isNotAComponent = function (node) {
    const isNotAComponent = typeof node.componentOptions === 'undefined'

    if (isNotAComponent) {
      return true
    }

    return false
  }

  const isWhiteSpace = function (node) {
    const isWhiteSpace = typeof node.tag === 'undefined'

    if (isWhiteSpace) {
      return true
    }

    return false
  }
</script>



// WEBPACK FOOTER //
// src/js/components/NodeDecorator.vue